function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactAvatar = function ContactAvatar($scope, LocaleService) {
    var _this = this;

    _classCallCheck(this, ContactAvatar);

    function getKanjiInitials(name) {
        if (name.length < 3) return name;
    }

    function getCompanyInitials(name) {
        var parts = name.split(' ');
        if (parts.length === 1) return name[0];
        return parts[0][0] + parts[1][0];
    }

    function getInitials(contact) {
        var countryCode = LocaleService.getCountry();
        var subtype = contact.subtype,
            displayName = contact.displayName,
            contactNameKanji = contact.contactNameKanji,
            lastNameKanji = contact.lastNameKanji,
            firstName = contact.firstName,
            lastName = contact.lastName;

        if (subtype === 'Company') {
            if (contactNameKanji) return getKanjiInitials(contactNameKanji);
            return getCompanyInitials(displayName);
        }
        if (lastNameKanji) return getKanjiInitials(lastNameKanji);
        if (countryCode === 'FR' || countryCode === 'JP') {
            return lastName[0] + firstName[0];
        }
        return firstName[0] + lastName[0];
    }

    this.$onInit = function () {
        _this.initials = getInitials(_this.contact);
    };
};

export default ContactAvatar;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/ContactAvatar/ContactAvatarCtrl.js
// module id = 1613
// module chunks = 0